import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'fa',
    fullName: 'Persian',
    nativeName: 'فارسی',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "چیزی شگفت انگیز در راه است",
    landing_subtitle: "ArgVoid یک استودیوی توسعه اپلیکیشن و بازی است. با ما همراه باشید، چیزهای جدید به زودی در راه است!",
    select_language: "زبان را انتخاب کنید",
    search_placeholder: "جستجوی زبان ها...",
    terms_title: "شرایط خدمات",
    policy_title: "سیاست حفظ حریم خصوصی",
    cookies_title: "خط مشی کوکی",
    terms_content: `
        <strong>1. پذیرش شرایط</strong><br>
        با دسترسی به ArgVoid، این شرایط خدمات پذیرفته می شود. در صورت عدم موافقت با این شرایط، از سرویس نباید استفاده شود.<br><br>

        <strong>2. استفاده از پلتفرم</strong><br>
        ArgVoid و برنامه های کاربردی آن "همانطور که هست" برای اهداف اطلاعاتی و خلاقانه ارائه شده است. این سرویس باید فقط برای مقاصد قانونی استفاده شود.<br><br>

        <strong>3. رفتار ممنوع</strong><br>
        بهره برداری از آسیب پذیری های سایت، ارسال هرزنامه، یا تلاش برای دسترسی غیرمجاز به زیرساخت اکیدا ممنوع است.<br><br>

        <strong>4. سلب مسئولیت</strong><br>
        پلتفرم و خدمات ممکن است در هر زمان بدون اطلاع قبلی تغییر یابد. هیچ ضمانتی در مورد زمان به روز بودن یا در دسترس بودن سرویس ارائه نمی شود.
    `,
    policy_content: `
        <strong>1. مجموعه اطلاعات</strong><br>
        این پلتفرم در حال حاضر نیازی به احراز هویت کاربر یا ایجاد حساب کاربری ندارد. هیچ اطلاعات شناسایی شخصی (مانند نام یا آدرس ایمیل) به طور فعال از بازدیدکنندگان جمع آوری نمی شود.<br><br>

        <strong>2. استفاده از Data</strong><br>
        ممکن است برای درک ترافیک سایت و بهبود برنامه‌ها، تجزیه و تحلیل‌های اولیه و ناشناس جمع‌آوری شود. این داده‌ها به هویت‌های کاربر منفرد مرتبط نیستند.<br><br>

        <strong>3. خدمات شخص ثالث</strong><br>
        ممکن است از ارائه دهندگان شخص ثالث برای خدمات میزبانی و تجزیه و تحلیل استفاده شود. اقدامات حفظ حریم خصوصی این ارائه دهندگان مربوطه بر داده های ناشناس پردازش شده در زیرساخت آنها حاکم است.<br><br>

        <strong>4. امنیت داده ها</strong><br>
        اقدامات امنیتی معقول برای محافظت از پلت فرم اجرا می شود. با این حال، هیچ روشی برای انتقال از طریق اینترنت کاملاً ایمن نیست.<br><br>
    `,
    cookies_content: `
        <strong>1. کوکی‌ها و ذخیره‌سازی محلی چیست؟</strong><br>
        کوکی‌ها و ذخیره‌سازی محلی مرورگر فایل‌های داده کوچکی هستند که در دستگاه ذخیره می‌شوند تا تنظیمات برگزیده پیکربندی را در بین بازدیدها به خاطر بسپارند.<br><br>

        <strong>2. هدف استفاده</strong><br>
        مرورگر LocalStorage به شدت برای ذخیره تنظیمات پیکربندی مانند:<br> استفاده می شود
        - ترجیحات زبان<br>
        - پیکربندی رابط کاربری (به عنوان مثال، تنظیمات طرح یا تم) <br>
        - برنامه موقت cache<br><br>

        <strong>3. بدون Tracking</strong><br>
        کوکی‌ها و ذخیره‌سازی محلی برای اهداف تبلیغاتی یا ردیابی شخص ثالث استفاده نمی‌شوند. تمام داده های ذخیره شده صرفاً برای عملکرد اصلی پلت فرم است.<br><br>

        <strong>4. Control</strong><br>
        داده های مرورگر را می توان در هر زمان از طریق تنظیمات مرورگر پاک کرد، که تنظیمات محلی را بازنشانی می کند.
    `,
    cookie_consent_text: "ما از کوکی‌های اولیه استفاده می‌کنیم تا از عملکرد صحیح وب‌سایت اطمینان حاصل کنیم، مانند فعال نگه داشتن جلسه شما، ذخیره اولویت زبان شما و سایر تنظیمات سفارشی.",
    read_policy: "خط مشی کوکی را بخوانید",
    support_title: "با پشتیبانی تماس بگیرید",
    support_subject_label: "موضوع",
    support_message_label: "پیام",
    support_submit_button: "ارسال پیام",
    support_hint: "توجه: با این کار برنامه ایمیل پیش فرض شما برای ارسال پیام باز می شود.",
    support_success_msg: "در حال باز کردن برنامه ایمیل...",
    support_error_msg: "پیام ارسال نشد. لطفاً بعداً دوباره امتحان کنید.",
    explorer_title: "کاوشگر",
    history_title: "تاریخچه",
    animation_title: "انیمیشن",
    config_title: "پیکربندی",
    tool_mouse: "انتخاب (Ctrl+M)",
    tool_brush: "قلم مو (Ctrl+B)",
    tool_brush_mode: "تغییر حالت (جامد/پاک)",
    tool_eraser: "پاک کن (Ctrl+E)",
    tool_brush_size: "اندازه برس را تنظیم کنید",
    tool_bucket: "پر کردن (Ctrl+F)",
    tool_eyedropper: "قطره چشم",
    tool_grid: "شبکه (Ctrl+Shift+B)",
    tool_rotate: "چرخش (Ctrl+Shift+R)",
    tool_flip_h: "چرخش H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "انتقال (Ctrl+Shift+T)",
    label_width: "عرض",
    label_height: "ارتفاع",
    label_frames: "تعداد فریم ها",
    label_animation: "سبک انیمیشن",
    label_background_color: "رنگ پس زمینه",
    label_interval: "فاصله",
    tool_anim_config: "پیکربندی انیمیشن",
    label_new_width: "عرض جدید",
    label_new_height: "ارتفاع جدید",
    label_apply: "درخواست کنید",
    label_colors: "رنگ ها",
    label_size: "اندازه",
    label_tolerance: "تحمل",
    val_horizontal: "افقی",
    val_vertical: "عمودی",
    val_sequence: "دنباله",
    val_bounce: "پرش",
    val_random: "تصادفی",
    val_solid: "جامد",
    val_clear: "پاک کردن",
    action_add_sheet: "برگه جدید",
    action_import: "واردات",
    action_export: "صادرات",
    action_sort_projects: "مرتب کردن",
    sort_date_old: "قدیمی ترین اول",
    sort_date_new: "جدیدترین اول",
    sort_name_az: "نام (A-Z)",
    sort_name_za: "نام (Z-A)",
    action_new_sprite: "جن جدید",
    action_new_project: "پروژه جدید",
    modal_save_all_title: "ذخیره همه تغییرات",
    modal_save_all_desc: "دارایی هایی را برای ذخیره انتخاب کنید:",
    modal_save_selected: "ذخیره انتخاب شده",
    action_saved: "ذخیره شد",
    modal_create_sprite_title: "Sprite جدید ایجاد کنید",
    modal_create_project_title: "ایجاد پروژه جدید",
    modal_add_sheet_title: "افزودن برگه جدید",
    modal_rename_sheet_title: "تغییر نام برگه",
    modal_rename_sprite_title: "تغییر نام Sprite",
    modal_delete_sprite_title: "Sprite را حذف کنید",
    modal_delete_project_title: "حذف پروژه",
    modal_delete_sheet_title: "برگه را حذف کنید",
    placeholder_sprite_name: "نام",
    placeholder_project_name: "نام",
    placeholder_sheet_name: "نام",
    placeholder_new_name: "نام جدید",
    action_create: "ایجاد کنید",
    action_add: "اضافه کنید",
    action_rename: "تغییر نام دهید",
    action_duplicate: "تکراری",
    action_delete: "حذف کنید",
    action_cancel: "لغو کنید",
    confirm_delete_sprite: "آیا مطمئن هستید که می خواهید این اسپرایت را حذف کنید؟",
    confirm_delete_project: "آیا مطمئن هستید که می خواهید این پروژه را حذف کنید؟ همه جن ها حذف خواهند شد.",
    confirm_delete_sheet: "آیا مطمئن هستید که می خواهید این برگه را حذف کنید؟",
    err_select_sprite: "لطفا ابتدا یک اسپرایت را انتخاب کنید.",
    err_select_project: "لطفا ابتدا یک پروژه را انتخاب کنید.",
    err_name_empty: "نام نمی تواند خالی باشد.",
    err_sprite_exists: "یک جن با آن نام از قبل وجود دارد.",
    err_project_exists: "پروژه ای با آن نام از قبل وجود دارد.",
    err_no_content: "محتوایی برای ذخیره وجود ندارد.",
    err_no_changes: "هیچ تغییری برای ذخیره وجود ندارد.",
    err_delete_last_sheet: "نمی توان آخرین برگه را حذف کرد.",
    err_extract_frames: "هیچ فریمی استخراج نشد.",
    err_indexeddb: "ذخیره محلی انجام نشد. ممکن است مرورگر شما از IndexedDB پشتیبانی نکند.",
    msg_upload_success: "آپلود با موفقیت انجام شد: {0}",
    msg_upload_failed: "آپلود انجام نشد: {0}",
    msg_save_success: "ذخیره موفقیت آمیز",
    msg_saving: "در حال ذخیره...",
    msg_multi_save_result: "{0} دارایی ذخیره شد. {1} شکست.",
    menu_title: "منو",
    menu_save: "ذخیره کنید",
    menu_save_all: "ذخیره همه",
    menu_support: "با پشتیبانی تماس بگیرید",
    label_local_storage: "محل ذخیره سازی",
    label_sign_in: "وارد شوید",
    modal_export_title: "صادرات اسپرایت",
    label_filename: "نام فایل",
    label_format: "قالب",
    action_export_confirm: "صادرات",
};

export default translations;
